import React from "react"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {findAssignments, FindAssignmentsArgs} from "../../resources/assignments"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {AmountInfoCircle} from "../AmountInfoCircle/AmountInfoCircle"

type AssignmentsAmountIndicatorProps = {
	findAssignmentsArgs: FindAssignmentsArgs
	refreshToken?: number
	isActive: boolean
	tooltip?: string | JSX.Element
}
export function AssignmentsAmountIndicator({
	findAssignmentsArgs,
	refreshToken,
	isActive,
	tooltip,
}: AssignmentsAmountIndicatorProps) {
	const findAssignmentsResult = useAsyncResult(() => findAssignments(findAssignmentsArgs), [refreshToken])
	return (
		<AsyncResultComponent asyncResult={findAssignmentsResult} pendingComponent={<></>}>
			{({value: result}) => {
				const assignmentAmount = result.meta?.pagination.total
				const assignmentAmountNumber = assignmentAmount ? Number(assignmentAmount) : undefined
				return !!assignmentAmountNumber && assignmentAmountNumber > 0 ? (
					<AmountInfoCircle amount={assignmentAmountNumber} tooltip={tooltip} isActive={isActive} />
				) : (
					<></>
				)
			}}
		</AsyncResultComponent>
	)
}
